import React, { useEffect, useRef } from 'react';

function InstOption({ showMenu, setShowMenu, children, className = '' }) {
    const ref = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current?.contains(event.target)) {
                setShowMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [setShowMenu]);

    if (!showMenu) return null;

    return (
        <div className={`inst-option ${className}`} ref={ref}>
            {children}
        </div>
    );
}

export default InstOption;
